import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { changeEventFilter } from '../../../../../store/actions/sportEvents';

const Orders = props => {
    const dispatch = useDispatch();

    const locale = useSelector(state => state.settings.locale);
    const orders = useSelector(state => state.sportEvents.filters.orders) || [];

    const options = orders.map(order => ({
        value: order.id,
        label: order.label,
        selected: order.selected,
    }));

    const selectedOption = options.find(option => option.selected);

    const onChange = value => {
        if (value.value === selectedOption.value) return;

        if (props.onChange) {
            props.onChange(value);
        }

        const newOrders = orders.map(order => ({ ...order, selected: order.id === value.value }));

        dispatch(changeEventFilter({ key: 'orders', value: newOrders }));
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedOption}
            onChange={onChange}
            options={options}
        />
    );
};

export default Orders;
